import ModalComponent from './Modal.vue';

const Modal = {}

// Vue暴露了一个install方法，用于自定义插件
Modal.install = function (Vue) {
    // 创建一个子类
    const ModalConstructor = Vue.extend(ModalComponent);
    // 实例化这个子类
    const instance = new ModalConstructor();
    // 创建一个div元素，并把实例挂载到div元素上
    instance.$mount(document.createElement('div'));
    // 将el插入到body元素中
    document.body.appendChild(instance.$el);

    // 添加实例方法
    // modal插件的实例方法
    Vue.prototype.$modal = config => {
        instance.type = config.type || 'info';
        instance.title = config.title;
        instance.content = config.content;
        instance.vShow = true;
    };
}

export default Modal;


// WEBPACK FOOTER //
// ./src/components/modal/index.js